exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-modal-content[data-v-c7e7ec66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center}.button-group[data-v-c7e7ec66]{margin-top:40px;display:grid;grid-gap:8px}.button-group .button[data-v-c7e7ec66]{width:300px;height:44px!important}", ""]);

// exports
